import React, { useState, useEffect, useRef } from 'react';
import PaginationEdu from './PaginationEdu';
import { useSelector } from 'react-redux';

function EduBox({ eduData, organization, chkReset, selectedItems, setSelectedItems, modifyLicense }) {
  const lang = useSelector(state => state.langReducer.lang);
  const searchPlaceholder = lang === 0 ? "라이선스no, 이메일, 이름" : "License no, Email, Name";

  // 다국어에 따른 드롭다운 항목 및 기본값 설정
  const droplistLicense = lang === 0
    ? ["라이선스 상태", "활성", "만료"]
    : ["License Status", "Active", "Expired", "Inactive"];
  const [dropLicense, setDropLicense] = useState(droplistLicense[0]);

  // lang이 변경되면 기본값 업데이트
  useEffect(() => {
    const defaultValue = lang === 0 ? "라이선스 상태" : "License Status";
    setDropLicense(defaultValue);
  }, [lang]);

  const [search, setSearch] = useState("");
  const [dropViewLicense, setDropViewLicense] = useState(false);

  // 드롭다운 외부 클릭 감지
  const dropLicenseRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropLicenseRef.current && !dropLicenseRef.current.contains(event.target)) {
        setDropViewLicense(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // eduData에 대해 검색어와 드롭다운 필터를 적용
  const filteredEdu = eduData.filter(item => {
    const searchLower = search.toLowerCase();
    const codeMatch = item.licenseCode?.toLowerCase().includes(searchLower);
    const userMatch = item.user
      ? ((item.user.email && item.user.email.toLowerCase().includes(searchLower)) ||
        (item.user.fullname && item.user.fullname.toLowerCase().includes(searchLower)))
      : false;
    const searchMatch = searchLower ? (codeMatch || userMatch) : true;

    let dropLicenseMatch = true;
    if (dropLicense === (lang === 0 ? '활성' : 'Active')) {
      dropLicenseMatch = item.revokedAt === null || new Date(item.revokedAt) > new Date();
    } else if (dropLicense === (lang === 0 ? '비활성' : 'Inactive')) {
      dropLicenseMatch = item.user === null;
    } else if (dropLicense === (lang === 0 ? '만료' : 'Expired')) {
      dropLicenseMatch = item.revokedAt !== null && new Date(item.revokedAt) < new Date();
    }

    return dropLicenseMatch && searchMatch;
  });

  return (
    <div className="licensing_box edu_box">
      <div className="title_box on">
        <p className="title">{lang === 0 ? "UModeler X School" : "UModeler X School"}</p>
      </div>
      <div className="licensing_info_box">
        <div className="search_box">
          <div className="input_box">
            <input
              type="text"
              placeholder={searchPlaceholder}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <img src={require("../assets/icon/search_black.svg").default} alt="search" />
          </div>
          <div
            className={`drop_box license ${dropViewLicense ? "on" : ""}`}
            onClick={(e) => {
              e.stopPropagation();
              setDropViewLicense(!dropViewLicense);
            }}
            ref={dropLicenseRef}
          >
            <span>{dropLicense}</span>
            {dropViewLicense && (
              <div className="drop_list">
                {droplistLicense.map((option, index) => (
                  <p
                    key={index}
                    onClick={() => {
                      setDropLicense(option);
                      setDropViewLicense(false);
                    }}
                  >
                    {option}
                  </p>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
      <PaginationEdu
        chkReset={chkReset}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
        modifyLicense={modifyLicense}
        coupon={filteredEdu}
      />
    </div>
  );
}

export default EduBox;